//#region src/utils/geolocation/distance-between-latlng.ts
/**
* Returns the distance in meters between two points
* @param lat1 number
* @param lng1 number
* @param lat2 number
* @param lng2 number
*/
function distanceBetweenLatLng(lat1, lng1, lat2, lng2) {
	const p = .017453292519943295;
	const c = Math.cos;
	const a = .5 - c((lat2 - lat1) * p) / 2 + c(lat1 * p) * c(lat2 * p) * (1 - c((lng2 - lng1) * p)) / 2;
	return +(12742e3 * Math.asin(Math.sqrt(a))).toFixed(1);
}
//#endregion
export { distanceBetweenLatLng };

//# sourceMappingURL=distance-between-latlng.js.map